import React, { useEffect, useState } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  Character,
  CharacterItem,
  CharacterBasicItem,
  CharacterAmmunition,
  CharacterCustomItem,
  CharacterWeapon,
  CharacterGem,
  Money,
  Campaign,
} from "@dndModels";

import API from "@utilities/smart_api";

import ButtonBox from "@components/input/buttons/ButtonBox";
import StringBox from "@components/input/strings/StringBox";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import CheckBox from "@components/input/CheckBox";
import CharConnectUtilities from '@dndUtilities/char_connect_utilities';

interface Props {
  char: Character | Campaign;
  char_item: CharacterItem;
  buying?: boolean;
  onChange: (repopulate: boolean, close: boolean) => void;
  onCancel: () => void;
}

const api = API.getInstance();
const connect_util = CharConnectUtilities.getInstance();

export default function CharacterItemSellingControls({
  char,
  char_item,
  buying = false,
  onChange,
  onCancel
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [selling_count, setSellingCount] = useState(1);
  const [sell_for_item_cost, setSellForItemCost] = useState(true);
  const [selling_for, setSellingFor] = useState(1);
  const [item_cost, setItemCost] = useState(1);
  const [ping, setPing] = useState(false);

  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      let gold_num = 1;
      if (char_item instanceof CharacterGem) {
        const size = char_item.size;
        let cost = char_item.base_item?.cost??0;
        if (size.true_id !== "") {
          cost = size.cost;
        }
        gold_num = cost;
      } else if (char_item instanceof CharacterCustomItem || 
        char_item instanceof CharacterBasicItem || char_item instanceof CharacterWeapon || 
        char_item instanceof CharacterAmmunition) {
        const cost = char_item.base_item?.cost??0;
        gold_num = cost;
      } else {
        gold_num = char_item.cost;
      }
      setItemCost(gold_num);
      setSellingFor(gold_num);
    }
  }, [fetched, char_item, setFetched, setItemCost, setSellingFor]);

  const enabled = api.user && (char.owner_id === api.user._id || (char instanceof Character && char.campaign && char.campaign.owner_id === api.user._id));

  const renderSelling = () => {
    const options: string[] = [];
    if (char_item instanceof CharacterAmmunition || char_item.stackable) {
      for (let i = 1; i <= char_item.count; ++i) {
        options.push(`${i}`);
      }
    }
    let sell_string = buying ? "Buy for " : "Sell for ";
    let gold_num = selling_for;
    if (sell_for_item_cost) {
      gold_num = item_cost;
    }
    gold_num = gold_num * selling_count;
    const gold_value = new Money();
    gold_value.copyGoldValue(gold_num);
    sell_string += gold_value.toString();
    return (
      <Grid container spacing={0} direction="row">
        { options.length > 1 ?
          <>
            <Grid
              size={{
                xs: 4
              }}>
              <SelectStringBox
                name={ `${buying ? "Buy" : "Sell"} Quantity` }
                value={ `${selling_count}` }
                options={options}
                onChange={(changed: string) => {
                  setSellingCount(+changed);
                }}
              />
            </Grid>
            <Grid
              size={{
                xs: 4
              }}>
              <CheckBox
                name={`${buying ? "Buy" : "Sell"} for Item Cost (${item_cost}gp each)`}
                value={sell_for_item_cost}
                onChange={setSellForItemCost}
              />
            </Grid>
            <Grid
              size={{
                xs: 4
              }}>
              { !sell_for_item_cost &&
                <StringBox
                  name={`${buying ? "Buy" : "Sell"} For (gp each)`}
                  value={selling_for}
                  type="number"
                  onBlur={(changed: string) => {
                    setSellingFor(+changed);
                  }}
                />
              }
            </Grid>
          </>
        :
          <>
            <Grid
              size={{
                xs: 6
              }}>
              <CheckBox
                name={`${buying ? "Buy" : "Sell"} for Item Cost (${item_cost}gp each)`}
                value={sell_for_item_cost}
                onChange={setSellForItemCost}
              />
            </Grid>
            <Grid
              size={{
                xs: 6
              }}>
              { !sell_for_item_cost &&
                <StringBox
                  name={`${buying ? "Buy" : "Sell"} For (gp each)`}
                  value={selling_for}
                  type="number"
                  onBlur={(changed: string) => {
                    setSellingFor(+changed);
                  }}
                />
              }
            </Grid>
          </>
        }
        <Grid
          size={{
            xs: 6
          }}>
          <ButtonBox 
            name={sell_string}
            disabled={ !enabled }
            onClick={() => {
              // debugger;
              const new_obj = char_item;
              if (new_obj instanceof CharacterGem || new_obj instanceof CharacterCustomItem || 
                new_obj instanceof CharacterBasicItem || new_obj instanceof CharacterWeapon || 
                new_obj instanceof CharacterAmmunition) {
                if (buying) {
                  new_obj.count += selling_count;
                  char.inventory.money.subtract(gold_value);
                } else {
                  new_obj.count -= selling_count;
                  char.inventory.money.add(gold_value);
                  if (new_obj.count === 0) {
                    connect_util.removeItem(char, char_item);
                  }
                }
              } else {
                if (buying) {

                } else {
                  connect_util.removeItem(char, char_item);
                }
              }
              onChange(false, false);
              setPing(!ping);
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 6
          }}>
          <ButtonBox 
            name="Cancel"
            onClick={onCancel}
          />
        </Grid>
      </Grid>
    );
  }

  return (
    <div className="centered">
      { renderSelling() }
    </div>
  );
}
